import * as Yup from "yup";


export const userPasswordSchema = Yup.object({
    current_psw: Yup.string().required('Current Password is required'),
    new_psw: Yup.string().required('Password is required'),
    confirm_psw: Yup.string()
    .oneOf([Yup.ref('new_psw'), null], 'Passwords must match')

}) 